var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicketMid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{fill:#cdc2da;}.cls-5{fill:#fcfcfc;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: -6.5,
    width: 1080,
    height: 69
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1080-75.74V132.77H0V-75.74A4.14,4.14,0,0,1,4-80H655.17a4.07,4.07,0,0,1,4,3.83C661-53.28,679-35.32,701-35.32s40-18,41.85-40.85a4.07,4.07,0,0,1,4-3.83H1076A4.14,4.14,0,0,1,1080-75.74Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 701,
    y: -80.5,
    width: 379,
    height: 230
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: -80,
    width: 701,
    height: 230
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1076-77a1.17,1.17,0,0,1,1,1.26V129.77H3V-75.74A1.17,1.17,0,0,1,4-77H655.17a1.08,1.08,0,0,1,1,1.06A48.68,48.68,0,0,0,670.41-45,43.52,43.52,0,0,0,701-32.32,43.52,43.52,0,0,0,731.59-45a48.68,48.68,0,0,0,14.25-30.92,1.08,1.08,0,0,1,1-1.06H1076m0-3H746.83a4.07,4.07,0,0,0-4,3.83C741-53.28,723-35.32,701-35.32s-40-18-41.85-40.85a4.07,4.07,0,0,0-4-3.83H4a4.14,4.14,0,0,0-4,4.26V132.77H1080V-75.74a4.14,4.14,0,0,0-4-4.26Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketMid);
export default __webpack_public_path__ + "static/media/ticket-mid.5b61c30db867c1a9b808be1e84c73173.svg";
export { ForwardRef as ReactComponent };